// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Menu ul {\n  padding: 0;\n}\n.edit-menu .MuiMenuItem-root {\n  width: -webkit-fill-available;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Menu/Menu.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;AACA;EACE,6BAA6B;AAC/B","sourcesContent":[".Menu ul {\n  padding: 0;\n}\n.edit-menu .MuiMenuItem-root {\n  width: -webkit-fill-available;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
